import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getInteriorParts } from '../thunks/partsThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearPartsKey } from '../thunkKeys/partsThunksKeys';

const SLICE_NAME = 'interiorParts';

export const interiorPartsSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearInteriorParts(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getInteriorParts });
        builder.addCase(clearPartsKey, () => commonInitialState);
    },
});

export const { clearInteriorParts } = interiorPartsSlice.actions;

export const interiorParts = interiorPartsSlice.reducer;
